import {CONST} from '../../../src/const';

class GameReelsetComponent extends SlotGame.src.component.ReelsetComponent {
    public TIME_STOP_DELAY = 400;
    public MIN_SPIN_DURATION = 300;

    private clustersArr = [[]];

    async onStartBonusGame() {
        await game.utils.delay(500);
        this.clustersArr = [[]];

        super.onStartBonusGame();
    }

    async onFinishBonusGame() {
        await game.utils.delay(500);

        super.onFinishBonusGame();
    }

    checkShowWinShowWinLines() {
        const isOneLine = this.store.gameData.lines.length == 1 && this.store.gameData.positions.length === 0;
        if (this.store.gameData.lines.length >= this.options.config.linesToSkip || (isOneLine && !this.checkShowBigWin())) return false;

        return this.store.gameData.hasLineWins() &&
            !(
                this.store.gameData.freeSpinsGame.isPlaying() ||
                this.store.gameData.freeSpinsGame.hasSpins() ||
                this.store.gameData.bonusGame.isPlaying() ||
                this.store.gameData.bonusGame.hasSpins() ||
                this.store.autoplay.isActive
            );
    }

    async onIdleWaitSpin() {
        this.playAllIdleAnimation();

        if (this.store.gameData.mode != "bonus") {
            await this.waitClick();
        }
    }

    async showBonusCluster() {
        this.store.gameData.bonusGame.extra?.clusters.forEach((cluster, i) => {
            let isNeedLockFrame = true;

            // for correct lock_frame position
            cluster.sort((a, b) => {
                // First sort by key Y
                if (a.y !== b.y) {
                    return a.y - b.y;
                }

                // Then sort by key X, if Y is equal
                return a.x - b.x;
            });

            cluster.forEach(({x, y, symbol, value}) => {
                if (cluster.length !== this.clustersArr[i]?.length) {
                    game.emit("ReelsetComponent.SHOW_BONUS_CLUSTER");
                    this.clustersArr[i] = cluster;
                }

                const isRightNeighbor = this.store.gameData.reels[x + 1] ? symbol === this.store.gameData.reels[x + 1][y]?.symbol : false;
                const isLeftNeighbor = this.store.gameData.reels[x - 1] ? symbol === this.store.gameData.reels[x - 1][y]?.symbol : false;
                const isUpNeighbor = this.store.gameData.reels[x][y - 1] ? symbol === this.store.gameData.reels[x][y - 1]?.symbol : false;
                const isDownNeighbor = this.store.gameData.reels[x][y + 1] ? symbol === this.store.gameData.reels[x][y + 1]?.symbol : false;

                const symbolHighlight = {
                    isRight: !isRightNeighbor,
                    isLeft: !isLeftNeighbor,
                    isUp: !isUpNeighbor,
                    isDown: !isDownNeighbor,
                };

                // @ts-ignore
                this.getSymbol(x, y).showCluster(symbolHighlight, isNeedLockFrame);
                // @ts-ignore
                this.getSymbol(x, y).setOverlayView(value);

                if (isNeedLockFrame) {
                    isNeedLockFrame = false;
                }
            })
        })

        await game.utils.delay(850);
    }

    async showBonusSymbolsWin() {

        this.playAllLoseAnimation();

        let positions = [];

        this.store.gameData.reels.forEach((reel, x) => {
            reel.forEach((sym, y) => {
                if (sym?.symbol == CONST.SYMBOLS.COIN) {
                    positions.push([x, y]);
                }
            })
        })

        // for winFrame
        game.emit("ReelsetComponent.SHOW_BONUS_SYMBOLS_WIN", {positions})

        if (positions.length >= 3) {
            await this.showWins(positions);
        }
    }

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            CHECK: {
                ...super.getFSMHandlers()['CHECK'],
                showBonusCluster: {
                    on: this.showBonusCluster.bind(this),
                    check: () => this.store.gameData.bonusGame.isPlaying()
                },
                showBonusWin: {
                    on: this.showBonusSymbolsWin.bind(this),
                    check: () => this.store.gameData.mode === "bonus" && (this.store.gameData.prevMode === "main" || this.store.gameData.prevMode === "freespins")
                }
            }
        }
    }
}

// @ts-ignore
Game.src.component.ReelsetComponent = GameReelsetComponent